import { Autocomplete, Box, FormControl, Grid, MenuItem, TextField } from '@mui/material';
import LoadingWheel from '../../../components/ui/LoadingWheel';
import { useContext } from 'react';
import { StockCountZonesContext, StockCountZonesContextValues } from '../contexts/StockCountZonesContext';
import { StoreModel } from '../../../app/services/api/generated';
import { filterStoreOptions } from '../../../utils';

const StockCountZonesMain = () => {
  const {
    t,
    zoneName,
    stores,
    selectedStores,
    setSelectedStores,
    setZoneName,
    isCreating,
    isLoading,
    countZoneTypes,
    selectedCountZoneType,
    setSelectedCountZoneType,
  } = useContext(StockCountZonesContext) as StockCountZonesContextValues;

  if (isLoading) {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        width: '100%',
      }}>
        <LoadingWheel />
      </Box>
    );
  }
  return (
    <Box sx={{ border: '1px solid', py: '12px', px: '8px' }}>
      <Grid container
        spacing={5}>
        <Grid item
          xs={12}
          md={4}>
          <FormControl fullWidth>
            <TextField
              label={t('countZoneName')}
              variant="outlined"
              value={zoneName}
              onChange={(e) => setZoneName(e.target.value)}
              disabled={!isCreating}
              required
            />
          </FormControl>
        </Grid>

        <Grid item
          xs={12}
          md={8}>
          <Autocomplete
            multiple
            size="small"
            sx={{
              '& .MuiAutocomplete-inputRoot': {
                maxHeight: 80,
                overflowY: 'auto',
              },
            }}
            options={stores}
            getOptionLabel={(option) => option.storeName ?? ''}
            filterOptions={filterStoreOptions}
            isOptionEqualToValue={(option, value) => option.storeNumber === value.storeNumber}
            value={selectedStores
              .map(storeNum => stores.find(s => s.storeNumber === storeNum))
              .filter(Boolean) as StoreModel[]}
            onChange={(event, newValue) => {
              const newStoreNumbers = newValue
                .map(s => s.storeNumber)
                .filter(Boolean) as string[];
              setSelectedStores(newStoreNumbers);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('selectStores')}
                placeholder={t('selectStores')}
                size="small"
              />
            )}
          />
        </Grid>

        <Grid item
          xs={12}
          md={4}>
          <FormControl fullWidth>
            <TextField
              select
              label={t('countZoneType')}
              value={countZoneTypes.some(ct => ct.id === selectedCountZoneType) ? selectedCountZoneType : -1}
              onChange={(e) => {
                const val = Number(e.target.value);
                setSelectedCountZoneType(val === -1 ? undefined : val);
              }}
              size="small"
              required
              SelectProps={{
                displayEmpty: true,
                renderValue: (value) => {
                  if (value === -1) {
                    return <span>{t('selectType')}</span>;
                  }
                  const selectedType = countZoneTypes.find(type => type.id === value);
                  return selectedType?.name || '';
                },
              }}
            >
              <MenuItem value={-1}>
                <span>{t('selectType')}</span>
              </MenuItem>

              {countZoneTypes.map((type) => (
                <MenuItem key={type.id}
                  value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
            </TextField>

          </FormControl>
        </Grid>

      </Grid>
    </Box>
  );
};

export default StockCountZonesMain;